import { styled } from "@mui/material/styles";

export const ShowCardContainer = styled("div")(({ theme }) => ({
  position: "relative",

  display: "flex",
  maxWidth: "414px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  alignSelf: "stretch",
  flexGrow: 1,
  borderRadius: "1rem",
  overflow: "hidden",
  
  background: theme.colors["neutral.900"],

  cursor: "pointer",

  //temporary hover effect - To be aligned with Martin
  transition: 'transform .5s',

  "&:hover, &:focus": {
    transform: 'scale3d(1.035, 1.035, 1)',
  }
}));

export const ShowCardBottomBar = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  alignSelf: "stretch",
  padding: "1rem",
}));